module.exports = __webpack_public_path__ + "images/twist-footer__1-4cp.png";